import CommentIcon from '@mui/icons-material/Comment';
import CloseIcon from '@mui/icons-material/Close';
import VerifiedIcon from '@mui/icons-material/Verified';
import CompareArrowsIcon from '@mui/icons-material/CompareArrows';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import TimelineIcon from '@mui/icons-material/Timeline';
import MoodBadIcon from '@mui/icons-material/MoodBad';
import RateReviewIcon from '@mui/icons-material/RateReview';
import TagFacesIcon from '@mui/icons-material/TagFaces';
import RefreshIcon from '@mui/icons-material/Refresh';
import {
  Alert,
  Backdrop,
  Badge,
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Chip,
  CircularProgress,
  Collapse,
  Divider,
  Grid,
  Snackbar,
  Stack,
  Tooltip,
  Typography
} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import Link from '@mui/material/Link';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TextField from '@mui/material/TextField';
import { makeStyles } from '@mui/styles';
import { DataGrid } from '@mui/x-data-grid';
import moment from 'moment';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  getMuadilProductList,
  getMuadilProductListStocks
} from 'src/store/slices/equivalentProductsSlice';
import {
  getProductProp,
  getWarranty
} from 'src/store/slices/generalFollowSlice';
import axios from 'src/utils/axios';
import CopyButton from 'src/components/CopyButton';

const useStyles = makeStyles((theme) => ({
  divCenter: {
    textAlign: 'left'
  },
  backdrop: {
    zIndex: 1500,
    color: '#fff'
  },
  divider: {
    backgroundColor: '#FF9800'
  },
  cardscontent: {
    minHeight: 250,
    width: '100%'
  },
  mainCard: {
    border: '1px solid #e0e0e0',
    borderRadius: '16px',
    position: 'sticky',
    top: 210,
    zIndex: 7,
    backgroundColor: '#fff',
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
    marginBottom: '16px'
  },
  cardHeader: {
    backgroundColor: '#f5f5f5',
    color: '#424242',
    padding: '10px 16px',
    cursor: 'move',
    borderBottom: '1px solid #e0e0e0',
    '& .MuiCardHeader-title': {
      fontSize: '12px',
      fontWeight: '700',
      letterSpacing: '0.5px'
    }
  },
  myClassName: {
    backgroundColor: 'transparent',
    position: 'relative'
  },
  Badge: {
    '& .css-106c1u2-MuiBadge-badge ': {
      backgroundColor: '#424242'
    }
  },
  div: {
    color: 'red',
    fontWeight: 'bold',
    fontSize: '14px',
    width: '100%'
  },
  div2: {
    fontSize: '12px',
    width: '100%',
    color: 'black'
  },
  icerikBilgi: {
    margin: '0px',
    fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
    fontWeight: '600',
    fontSize: '12px',
    lineHeight: '1.43',
    letterSpacing: '0.01071em',
    color: 'black',
    marginBottom: '7.5px',
    display: 'flex',
    alignItems: 'center'
  },
  bilgiLabel: {
    width: '72px',
    flexShrink: 0
  },
  tableCell: {
    fontWeight: '600',
    fontSize: '14px',
    color: 'black',
    whiteSpace: 'nowrap'
  },
  tableCellBilgi: {
    fontSize: '14px',
    color: 'black'
  }
}));

function ChangeProductInfo() {
  const dispatch = useDispatch();
  const classes = useStyles();
  const invoiceData = useSelector(
    (state) => state.generalFollowSlice.invoiceDetail
  );

  const [loading, setLoading] = React.useState(false);
  const [muadilData, setMuadilData] = React.useState([]);

  const [productData, setProductData] = React.useState([]);
  const [equivalentPopUp, setEquivalentPopUp] = React.useState(false); //muadil pop-up
  const [warrantyTypePopUp, setWarrantyTypePopUp] = React.useState(false);
  const [selectedServiceRefundPopUp, setSelectedServiceRefundPopUp] =
    React.useState(false);
  const [warrantyData, setWarrantyData] = React.useState([]);
  const [warrantyLoading, setWarrantyLoading] = React.useState(false);
  const [warrantyError, setWarrantyError] = React.useState('');
  const warrantyRequestRef = React.useRef(null);
  const [selectedRefundData, setSelectedRefundData] = React.useState([]);
  const [muadilPrice, setMuaidilPrice] = React.useState(0);
  const [manuelMuadilScreenActive, setManuelMuadilScreenActive] =
    React.useState(false);
  const [productList, setProductList] = React.useState([]);
  const [detailLoading, setDetailLoading] = React.useState(false);
  const [detailManuelLoading, setDetailManuelLoading] = React.useState(false);
  const [responseMessage, setresponseMessage] = React.useState({
    ErrorCode: '0',
    ErrorDescription: 'success_message'
  });
  const [uyari, setUyari] = React.useState(false);
  const [collapsed, setCollapsed] = React.useState(false);
  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };

  const handleToggleCollapse = () => {
    setCollapsed(!collapsed);
  };

  const columns = [
    { field: 'ACIKLAMA', headerName: 'Servis Red Nedeni', flex: 1 }
  ];

  const getMuadil = () => {
    setMuadilData([]);
    setLoading(true);
    const data = {
      ProductCode: invoiceData[0]?.Model?.UserModelCode1?.toString(),
      UnitCode: invoiceData[0]?.Exchange?.Service?.toString(),
      ApplicationNumber: invoiceData[0]?.Exchange?.ApplyNo?.toString(),
      ReceiptNumber: invoiceData[0]?.Apply?.ReceiptNumber.toString()
    };
    dispatch(getProductProp(data)).then((response) => {
      setEquivalentPopUp(true);
      if (response.payload.length > 0) {
        setMuaidilPrice(response?.payload[0]?.PRICE);
        setProductData(response?.payload);
      }
      setLoading(false);
      setDetailLoading(true);
      axios
        .post('GetMuadilList', data, {
          headers: { 'Content-Type': 'application/json' }
        })
        .then((response) => {
          setMuadilData(response.data);
          setDetailLoading(false);
          if (response.data.includes('error') == true) {
            setresponseMessage({
              ErrorCode: 1000,
              ErrorDescription: response.data
            });
            setUyari(true);
            return;
          }
        })
        .catch((err) => {
          setLoading(false);
        });
    });
  };

  function getWarrantyType() {
    const data = [
      invoiceData[0]?.Model?.ProductId,
      invoiceData[0]?.Apply.SerialNumber,
      invoiceData[0]?.Apply.UYear,
      invoiceData[0]?.Apply.UMonth,
      invoiceData[0]?.Apply.AttributeCode
    ];

    if (!data[0] || !data[1] || !data[2] || !data[3] || !data[4]) {
      return;
    }

    // Devam eden bir sorgu varsa iptal edilip yenisi başlatılır
    if (warrantyRequestRef.current) {
      warrantyRequestRef.current.abort();
    }
    setWarrantyData([]);
    setWarrantyError('');
    setWarrantyTypePopUp(true);
    setWarrantyLoading(true);
    const request = dispatch(getWarranty(data));
    warrantyRequestRef.current = request;
    request.then((response) => {
      // Popup kapatılıp istek iptal edildiyse sonucu yok say
      if (response.meta?.aborted || warrantyRequestRef.current !== request) {
        return;
      }
      warrantyRequestRef.current = null;
      if (response.meta?.requestStatus === 'rejected') {
        // Sadece istek gerçekten başarısız olduysa hata gösterilir
        setWarrantyError('Garanti bilgileri alınamadı. Lütfen tekrar deneyiniz.');
      } else {
        // Kayıt yoksa API boş döner (204); bu hata değil, "bulunamadı" olarak gösterilir
        setWarrantyData(Array.isArray(response.payload) ? response.payload : []);
      }
      setWarrantyLoading(false);
    });
  }

  const closeWarrantyPopUp = () => {
    if (warrantyRequestRef.current) {
      warrantyRequestRef.current.abort();
      warrantyRequestRef.current = null;
    }
    setWarrantyLoading(false);
    setWarrantyTypePopUp(false);
  };

  function degTarihce(bk, bn) {
    var deger;
    deger = '&BASVURU_NO=' + bk;
    deger += '&BIRIM_KODU=' + bn;
    var targetPage =
      'http://arreportsql/ReportServer/Pages/ReportViewer.aspx?%2fTHRaporlar/Genel%2fUrunDegisimTarihceYeni&rs:Command=Render&rc:Toolbar=true&rc:Parameters=false' +
      deger;
    var width = 1150;
    var height = 500;
    var left = parseInt(window.screen.availWidth / 2 - width / 2);
    var top = parseInt(window.screen.availHeight / 2 - height / 2);
    var windowFeatures =
      'width=' +
      width +
      ',height=' +
      height +
      ',status,resizable,left=' +
      left +
      ',top=' +
      top +
      'screenX=' +
      left +
      ',screenY=' +
      top;
    window.open(targetPage, 'subWind', windowFeatures);
  }

  function degFisGoster(bk, bn) {
    var deger;
    deger = '&bn=' + bn;
    deger += '&bk=' + bk;
    var targetPage =
      'microsoft-edge:http://mhnet/THPortal/FISSORGU/FisGoster.aspx?' + deger;
    var width = 1150;
    var height = 500;
    var left = parseInt(window.screen.availWidth / 2 - width / 2);
    var top = parseInt(window.screen.availHeight / 2 - height / 2);
    var windowFeatures =
      'width=' +
      width +
      ',height=' +
      height +
      ',status,resizable,left=' +
      left +
      ',top=' +
      top +
      'screenX=' +
      left +
      ',screenY=' +
      top;
    const newWindow = window.open(targetPage, 'subWind', windowFeatures); // Chrome veya diğer tarayıcılar üzerinden açılan sayfanın kapanmasını sağlamak için
    if (newWindow) {
      setTimeout(() => {
        newWindow.close();
      }, 15000); // 1 saniye bekleyip kapatmaya çalışır
    }
  }

  function degYorumGoster(bk, bn) {
    var deger;
    deger = '&BASVURU_NO=' + bn;
    deger += '&BIRIM_KODU=' + bk;
    var targetPage =
      'microsoft-edge:http://arreportsql/ReportServer/Pages/ReportViewer.aspx?%2fTHRaporlar/Genel%2fFisYorum&rs:Command=Render&rc:Toolbar=true&rc:Parameters=false' +
      deger;
    var width = 1150;
    var height = 500;
    var left = parseInt(window.screen.availWidth / 2 - width / 2);
    var top = parseInt(window.screen.availHeight / 2 - height / 2);
    var windowFeatures =
      'width=' +
      width +
      ',height=' +
      height +
      ',status,resizable,left=' +
      left +
      ',top=' +
      top +
      'screenX=' +
      left +
      ',screenY=' +
      top;
    const newWindow = window.open(targetPage, 'subWind', windowFeatures); // Chrome veya diğer tarayıcılar üzerinden açılan sayfanın kapanmasını sağlamak için
    if (newWindow) {
      setTimeout(() => {
        newWindow.close();
      }, 15000); // 1 saniye bekleyip kapatmaya çalışır
    }
  }

  function degYorumYaz(bk, bn, fis, Id) {
    var deger;
    deger = 'FIS_NO=' + Id;
    deger += '&BASVURU_NO=' + bk;
    deger += '&BIRIM_KODU=' + bn;
    deger += '&GELENLINK=UrunDegisimMuhendis';

    var targetPage =
      'microsoft-edge:http://mhnet/THPortal/YORUM/aspx/Main.aspx?' + deger;

    var width = 1150;
    var height = 500;
    var left = parseInt(window.screen.availWidth / 2 - width / 2);
    var top = parseInt(window.screen.availHeight / 2 - height / 2);
    var windowFeatures =
      'width=' +
      width +
      ',height=' +
      height +
      ',status,resizable,left=' +
      left +
      ',top=' +
      top +
      'screenX=' +
      left +
      ',screenY=' +
      top;
    const newWindow = window.open(targetPage, 'subWind', windowFeatures); // Chrome veya diğer tarayıcılar üzerinden açılan sayfanın kapanmasını sağlamak için
    if (newWindow) {
      setTimeout(() => {
        newWindow.close();
      }, 15000); // 1 saniye bekleyip kapatmaya çalışır
    }
  }

  const handleOpenManualMdmScreen = (userModel, ServiceNumber, isActive) => {
    //Aynı muadil sayfası açık olması durumunda buton ile
    //tekrar tetiklenme durumunun engellenmesi için bu koşul eklenmiştir.
    if (manuelMuadilScreenActive) {
      return;
    }
    //Product Listesi Temizleme İşlemi
    setProductList([]);
    //Manuel Muadil Butonuna basıldığında Manuel Muadil Listesinin Gözükmesini Sağlamaktadır.
    if (isActive === 1) {
      setManuelMuadilScreenActive(true);
    }

    const data = [
      userModel,
      ServiceNumber,
      invoiceData[0]?.Apply?.ReceiptNumber
    ];

    setDetailManuelLoading(true);
    dispatch(getMuadilProductListStocks(data))
      .then((response) => {
        if (response.payload.length > 0) {
          setProductList(response?.payload);
        } else {
          setresponseMessage({
            ErrorCode: 1000,
            ErrorDescription: `Manuel Muadil Hata: ${invoiceData[0]?.Model?.UserModelCode} İçin Uygun Muadil Ürün Bulunamadı! MDM Muadil Ürün aramaya devam ediyor! Lütfen Bekleyiniz...`
          });
          setUyari(true);
        }
        setDetailManuelLoading(false);
      })
      .catch((er) => {
        setDetailManuelLoading(false);
      });
  };

  const handleOpenAutomaticMdmScreen = () => {
    //Aynı muadil sayfası açık olması durumunda buton ile
    //tekrar tetiklenme durumunun engellenmesi için bu koşul eklenmiştir.
    if (!manuelMuadilScreenActive) {
      return;
    }
    setManuelMuadilScreenActive(false);
    getMuadil(); // MDM Muadil Bilgilerini getiriyor.
    handleOpenManualMdmScreen(
      invoiceData[0]?.Model?.ProductId,
      invoiceData[0]?.Exchange?.Service,
      0
    ); // Manuel Muadil Bilgilerini getiriyor.
  };

  return (
    <>
      <Stack spacing={8}>
        <Snackbar
          sx={{ width: '100%' }}
          open={uyari}
          autoHideDuration={6000}
          onClose={uyariKapat}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center'
          }}
        >
          {responseMessage.ErrorCode === 1000 ? (
            <Alert
              icon={<MoodBadIcon />}
              style={{ minWidth: 500 }}
              sx={{
                '& .MuiAlert-icon': {
                  color: 'white'
                },
                height: 75,
                alignItems: 'center',
                verticalAlign: 'center'
              }}
              onClose={uyariKapat}
              variant="filled"
              severity="error"
            >
              {responseMessage.ErrorDescription}
            </Alert>
          ) : (
            <Alert
              icon={<TagFacesIcon />}
              style={{ minWidth: 500 }}
              sx={{
                '& .MuiAlert-icon': {
                  color: 'white'
                },
                height: 75,
                alignItems: 'center',
                verticalAlign: 'center'
              }}
              onClose={uyariKapat}
              variant="filled"
              severity="success"
            >
              {responseMessage.ErrorDescription}
            </Alert>
          )}
        </Snackbar>
      </Stack>
      <Backdrop className={classes.backdrop} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Card className={classes.mainCard}>
        <CardHeader
          className={classes.cardHeader}
          avatar={<DragIndicatorIcon sx={{ color: '#FF9800' }} />}
          action={
            <Tooltip title={collapsed ? 'Genişlet' : 'Daralt'}>
              <IconButton
                onClick={handleToggleCollapse}
                sx={{ color: '#FF9800' }}
              >
                {collapsed ? <ExpandMoreIcon /> : <ExpandLessIcon />}
              </IconButton>
            </Tooltip>
          }
          title="Değişen Ürün Bilgileri"
        />
        <Collapse in={!collapsed} timeout="auto" unmountOnExit>
          <CardContent sx={{ padding: '12px' }}>
            <Grid container spacing={2} style={{ paddingTop: 5 }}>
              <Grid item xs={6} md={6} sx={{ minWidth: 0 }}>
                <Typography
                  variant="body2"
                  color="textSecondary"
                  component="div"
                  className={classes.icerikBilgi}
                  sx={{
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    color: '#757575',
                    fontSize: '11px'
                  }}
                >
                  <span className={classes.bilgiLabel}>Fiş No:</span>
                  <Typography
                    variant="body2"
                    color="textSecondary"
                    component="span"
                    className={classes.div2}
                    sx={{ color: '#263238', fontSize: '12px' }}
                  >
                    <Link
                      sx={{ color: '#424242' }}
                      onClick={() =>
                        degFisGoster(
                          invoiceData[0]?.Exchange?.Service,
                          invoiceData[0]?.Exchange?.ApplyNo
                        )
                      }
                    >
                      {invoiceData[0]?.Apply?.ReceiptNumber
                        ? invoiceData[0]?.Apply?.ReceiptNumber
                        : '-'}
                    </Link>
                    {invoiceData[0]?.Apply?.ReceiptNumber && (
                      <CopyButton
                        value={invoiceData[0]?.Apply?.ReceiptNumber}
                        title="Fiş numarasını kopyala"
                        sx={{ ml: 0.5 }}
                      />
                    )}
                  </Typography>
                </Typography>
              </Grid>
              <Grid item xs={6} md={6}>
                <Typography
                  variant="body2"
                  color="textSecondary"
                  component="div"
                  sx={{
                    fontWeight: 'bold',
                    width: '100%',
                    color: '#FF9800',
                    fontSize: '12px'
                  }}
                >
                  {invoiceData[0]?.Apply?.AttributeCode === 1
                    ? 'Revizyonlu'
                    : ''}
                </Typography>
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item xs={10} md={10} sx={{ minWidth: 0 }}>
                <Typography
                  variant="body2"
                  color="textSecondary"
                  component="div"
                  className={classes.icerikBilgi}
                  sx={{
                    wordBreak: 'break-word',
                    color: '#757575',
                    fontSize: '11px'
                  }}
                >
                  <span className={classes.bilgiLabel}>Ürün:</span>
                  <Typography
                    variant="body2"
                    color="textSecondary"
                    component="span"
                    className={classes.div2}
                    sx={{
                      wordBreak: 'break-word',
                      color: '#263238',
                      fontSize: '12px'
                    }}
                  >
                    {invoiceData[0]?.Model?.UserModelCode1}-
                    {invoiceData[0]?.Model?.ProductDesc}
                  </Typography>
                </Typography>
              </Grid>
              <Grid item xs={2}>
                <Typography
                  variant="body2"
                  color="textSecondary"
                  component="div"
                  sx={{
                    fontWeight: 'bold',
                    width: '100%',
                    color: '#FF9800',
                    fontSize: '12px'
                  }}
                >
                  {invoiceData[0]?.ISOSAS}
                </Typography>
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item xs={12} md={12} sx={{ minWidth: 0 }}>
                <Typography
                  variant="body2"
                  color="textSecondary"
                  component="div"
                  className={classes.icerikBilgi}
                  sx={{ color: '#757575', fontSize: '11px' }}
                >
                  <span className={classes.bilgiLabel}>Yıl/Ay/Seri:</span>
                  <Typography
                    variant="body2"
                    color="textSecondary"
                    component="span"
                    className={classes.div2}
                    sx={{ color: '#263238', fontSize: '12px' }}
                  >
                    {invoiceData[0]?.Apply?.UYear +
                      '/' +
                      invoiceData[0]?.Apply?.UMonth +
                      '/' +
                      invoiceData[0]?.Apply?.SerialNumber}
                  </Typography>
                </Typography>
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item xs={12} md={12} sx={{ minWidth: 0 }}>
                <Typography
                  variant="body2"
                  color="textSecondary"
                  component="div"
                  className={classes.icerikBilgi}
                  sx={{ color: '#757575', fontSize: '11px' }}
                >
                  <span className={classes.bilgiLabel}>Garanti:</span>
                  <Typography
                    variant="body2"
                    color="textSecondary"
                    component="span"
                    className={classes.div2}
                    sx={{ color: '#263238', fontSize: '12px' }}
                  >
                    {invoiceData[0]?.Apply?.GuaranteeDate
                      ? moment(invoiceData[0]?.Apply?.GuaranteeDate).format(
                          'DD/MM/YYYY'
                        )
                      : '-'}
                  </Typography>
                </Typography>
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item xs={12} md={12} sx={{ minWidth: 0 }}>
                <Typography
                  variant="body2"
                  color="textSecondary"
                  component="div"
                  className={classes.icerikBilgi}
                  sx={{
                    wordBreak: 'break-all',
                    color: '#757575',
                    fontSize: '11px'
                  }}
                >
                  <span className={classes.bilgiLabel}>Barkod:</span>
                  <Typography
                    variant="body2"
                    color="textSecondary"
                    component="span"
                    className={classes.div2}
                    sx={{ color: '#263238', fontSize: '12px' }}
                  >
                    {invoiceData[0]?.Apply?.Barcode}
                  </Typography>
                </Typography>
              </Grid>
            </Grid>
            <Grid container spacing={2} style={{ paddingTop: 10 }}>
              <Grid item xs={12} md={12}>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                  }}
                >
                  <Tooltip title="Yorumları Görüntüle">
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'column-reverse',
                        alignItems: 'center',
                        cursor: 'pointer',
                        '&:hover': { opacity: 0.8 }
                      }}
                      onClick={() =>
                        degYorumGoster(
                          invoiceData[0]?.Exchange?.Service,
                          invoiceData[0]?.Exchange?.ApplyNo
                        )
                      }
                    >
                      <Badge
                        className={classes.Badge}
                        badgeContent={invoiceData[0]?.Apply?.CommentCount}
                        color="primary"
                      >
                        <CommentIcon
                          sx={{ color: '#FF9800', fontSize: '24px' }}
                        />
                      </Badge>
                      <Typography
                        sx={{
                          fontSize: '11px',
                          color: '#263238',
                          mb: 0.5,
                          fontWeight: '700'
                        }}
                      >
                        Yorum
                      </Typography>
                    </Box>
                  </Tooltip>

                  <Tooltip title="Yorum Yaz">
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'column-reverse',
                        alignItems: 'center',
                        cursor: 'pointer',
                        '&:hover': { opacity: 0.8 }
                      }}
                      onClick={() =>
                        degYorumYaz(
                          invoiceData[0]?.Exchange?.ApplyNo,
                          invoiceData[0]?.Exchange?.Service,
                          invoiceData[0]?.Exchange?.ReceiptNumber
                        )
                      }
                    >
                      <RateReviewIcon
                        sx={{ color: '#FF9800', fontSize: '24px' }}
                      />
                      <Typography
                        sx={{
                          fontSize: '11px',
                          color: '#263238',
                          mb: 0.5,
                          fontWeight: '700'
                        }}
                      >
                        Yorum Yaz
                      </Typography>
                    </Box>
                  </Tooltip>

                  <Tooltip title="Değişim Tarihçesi">
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'column-reverse',
                        alignItems: 'center',
                        cursor: 'pointer',
                        '&:hover': { opacity: 0.8 }
                      }}
                      onClick={() =>
                        degTarihce(
                          invoiceData[0]?.Exchange?.ApplyNo,
                          invoiceData[0]?.Exchange?.Service
                        )
                      }
                    >
                      <TimelineIcon
                        sx={{ color: '#FF9800', fontSize: '24px' }}
                      />
                      <Typography
                        sx={{
                          fontSize: '11px',
                          color: '#263238',
                          mb: 0.5,
                          fontWeight: '700'
                        }}
                      >
                        Tarihçe
                      </Typography>
                    </Box>
                  </Tooltip>

                  <Tooltip title="Muadil Ürünler">
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'column-reverse',
                        alignItems: 'center',
                        cursor: 'pointer',
                        '&:hover': { opacity: 0.8 }
                      }}
                      onClick={() => {
                        setManuelMuadilScreenActive(false);
                        getMuadil();
                        handleOpenManualMdmScreen(
                          invoiceData[0]?.Model?.ProductId,
                          invoiceData[0]?.Exchange?.Service,
                          0
                        );
                      }}
                    >
                      <CompareArrowsIcon
                        sx={{ color: '#FF9800', fontSize: '24px' }}
                      />
                      <Typography
                        sx={{
                          fontSize: '11px',
                          color: '#263238',
                          mb: 0.5,
                          fontWeight: '700'
                        }}
                      >
                        Muadil
                      </Typography>
                    </Box>
                  </Tooltip>

                  <Tooltip title="Garanti Bilgileri">
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'column-reverse',
                        alignItems: 'center',
                        cursor: 'pointer',
                        '&:hover': { opacity: 0.8 }
                      }}
                      onClick={() => {
                        getWarrantyType();
                      }}
                    >
                      <VerifiedIcon
                        sx={{ color: '#FF9800', fontSize: '24px' }}
                      />
                      <Typography
                        sx={{
                          fontSize: '11px',
                          color: '#263238',
                          mb: 0.5,
                          fontWeight: '700'
                        }}
                      >
                        Garanti Bilgileri
                      </Typography>
                    </Box>
                  </Tooltip>
                </Box>
              </Grid>
            </Grid>
          </CardContent>
        </Collapse>

        {/* // sx={{ Muadil Pop-up }} */}

        <Dialog
          open={equivalentPopUp}
          // onClose={() => setEquivalentPopUp(false)}
          aria-describedby="alert-dialog-slide-description"
          fullWidth
          maxWidth="xl"
        >
          <DialogTitle sx={{ width: '100%' }}>
            <Stack direction={'row'} spacing={1}>
              <Button
                color="primary"
                variant="contained"
                sx={{ color: '#FF9800', backgroundColor: '#424242' }}
                onClick={() => {
                  handleOpenAutomaticMdmScreen();
                }}
              >
                Mdm Muadil
              </Button>
              <Button
                color="primary"
                variant="contained"
                sx={{ color: '#FF9800', backgroundColor: '#424242' }}
                onClick={() => {
                  handleOpenManualMdmScreen(
                    invoiceData[0]?.Model?.ProductId,
                    invoiceData[0]?.Exchange?.Service,
                    1
                  );
                }}
              >
                Manuel Muadil
              </Button>
            </Stack>
          </DialogTitle>
          <DialogContent>
            <Grid container spacing={2} style={{ paddingTop: 20 }}>
              <Grid item xs={4} md={4}>
                <TextField
                  id="outlined-start-adornment"
                  fullWidth
                  size="small"
                  value={invoiceData[0]?.Model?.UserModelCode}
                  disabled
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        Stok Kodu
                      </InputAdornment>
                    )
                  }}
                />
              </Grid>
              <Grid item xs={4} md={4}>
                <TextField
                  id="outlined-start-adornment"
                  fullWidth
                  size="small"
                  value={invoiceData[0]?.Model?.ProductDesc}
                  disabled
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">Açıklama</InputAdornment>
                    )
                  }}
                />
              </Grid>
              <Grid item xs={4} md={4}>
                <TextField
                  id="outlined-start-adornment"
                  fullWidth
                  size="small"
                  disabled
                  value={muadilPrice}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">Fiyat</InputAdornment>
                    )
                  }}
                />
              </Grid>
            </Grid>
            <Grid container spacing={2} style={{ paddingTop: 40 }}>
              <Typography
                sx={{ width: '100%', fontWeight: 'bold' }}
                variant="subtitle1"
              >
                Ürün
              </Typography>
              <TableContainer
                className={classes.container}
                sx={{ maxHeight: 440 }}
              >
                <Table stickyHeader aria-label="sticky table" size="small">
                  <TableHead>
                    <TableRow>
                      {productData?.map((row, index) => (
                        <TableCell
                          style={{ width: '1px', whiteSpace: 'nowrap' }}
                          key={index}
                        >
                          {row.ATTRIBUTE_DESCRIPTION}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                      {productData?.map((row, index) => (
                        <TableCell
                          key={index}
                          style={{ width: '1px', whiteSpace: 'nowrap' }}
                        >
                          {row.ATTRIBUTE_VALUE}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>

              <Divider className={classes.divider} />
              {!manuelMuadilScreenActive ? (
                <>
                  <Typography
                    sx={{ width: '100%', fontWeight: 'bold' }}
                    variant="subtitle1"
                  >
                    Manuel Muadiller
                  </Typography>
                  <TableContainer
                    className={classes.container}
                    sx={{ maxHeight: 450 }}
                  >
                    <Table
                      stickyHeader
                      fullWidth
                      aria-label="sticky table"
                      size="medium"
                      sx={{ minHeight: 100 }}
                    >
                      <TableHead>
                        <TableRow>
                          <TableCell
                            align="center"
                            style={{ width: '1px', whiteSpace: 'nowrap' }}
                          >
                            Ürün Kodu
                          </TableCell>
                          <TableCell
                            align="center"
                            style={{ width: '1px', whiteSpace: 'nowrap' }}
                          >
                            Ürün Adı
                          </TableCell>
                          <TableCell
                            align="center"
                            style={{ width: '1px', whiteSpace: 'nowrap' }}
                          >
                            Öncelik Sırası
                          </TableCell>
                          <TableCell
                            align="center"
                            style={{ width: '1px', whiteSpace: 'nowrap' }}
                          >
                            Muadil Tipi
                          </TableCell>
                          <TableCell
                            align="center"
                            style={{ width: '1px', whiteSpace: 'nowrap' }}
                          >
                            Geçerlilik Süresi
                          </TableCell>
                          <TableCell
                            align="center"
                            style={{ width: '1px', whiteSpace: 'nowrap' }}
                          >
                            Muadil Açıklama
                          </TableCell>
                          <TableCell
                            align="center"
                            style={{ width: '1px', whiteSpace: 'nowrap' }}
                          >
                            Depo Adı
                          </TableCell>
                          <TableCell
                            align="center"
                            style={{ width: '1px', whiteSpace: 'nowrap' }}
                          >
                            Stok Adet
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {detailManuelLoading == true ? (
                          <TableCell colSpan={9}>
                            <Stack
                              spacing={9}
                              alignItems="center"
                              justifyContent="center"
                            >
                              <CircularProgress size={50} color="success" />
                            </Stack>
                          </TableCell>
                        ) : (
                          productList.length > 0 &&
                          productList.map((row, index) => (
                            <TableRow key={index}>
                              <TableCell
                                align="center"
                                style={{ width: '1px', whiteSpace: 'nowrap' }}
                              >
                                {row.SKU}
                              </TableCell>
                              <TableCell
                                align="center"
                                style={{ width: '1px', whiteSpace: 'nowrap' }}
                              >
                                {row.ACIKLAMA}
                              </TableCell>
                              <TableCell
                                align="center"
                                style={{ width: '1px', whiteSpace: 'nowrap' }}
                              >
                                {row.ONCELIK_SIRASI}
                              </TableCell>
                              <TableCell
                                align="center"
                                style={{ width: '1px', whiteSpace: 'nowrap' }}
                              >
                                {row.MUADIL_TIPI}
                              </TableCell>
                              <TableCell
                                align="center"
                                style={{ width: '1px', whiteSpace: 'nowrap' }}
                              >
                                {moment(row.GECERLILIK_SURESI).format(
                                  'DD/MM/YYYY'
                                )}
                              </TableCell>
                              <TableCell
                                align="center"
                                style={{ width: '1px', whiteSpace: 'nowrap' }}
                              >
                                {row.MUADIL_ACIKLAMA}
                              </TableCell>
                              <TableCell
                                align="center"
                                style={{ width: '1px', whiteSpace: 'nowrap' }}
                              >
                                {row.StockName ? row.StockName : ''}
                              </TableCell>
                              <TableCell
                                align="center"
                                style={{ width: '1px', whiteSpace: 'nowrap' }}
                              >
                                {row.StockTotal ? row.StockTotal : ''}
                              </TableCell>
                            </TableRow>
                          ))
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  <Typography
                    sx={{ width: '100%', fontWeight: 'bold' }}
                    variant="subtitle1"
                  >
                    MDM Muadiller
                  </Typography>
                  <TableContainer
                    className={classes.container}
                    sx={{ maxHeight: 440 }}
                  >
                    <Table
                      stickyHeader
                      aria-label="sticky table"
                      size="large"
                      sx={{ minHeight: 100 }}
                    >
                      <TableHead>
                        <TableRow>
                          {muadilData?.columns?.map((col, index) => (
                            <TableCell
                              style={{ width: '1px', whiteSpace: 'nowrap' }}
                              key={index}
                            >
                              {col}
                            </TableCell>
                          ))}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {detailLoading == true ? (
                          <Stack spacing={8} alignItems="center">
                            <CircularProgress size={50} color="success" />{' '}
                          </Stack>
                        ) : (
                          muadilData?.data?.map((row, index) => (
                            <TableRow
                              sx={{
                                '&:last-child td, &:last-child th': {
                                  border: 0
                                }
                              }}
                              key={index}
                            >
                              {row?.map((col, index) => (
                                <TableCell
                                  key={index}
                                  style={{ width: '1px', whiteSpace: 'nowrap' }}
                                >
                                  {col}
                                </TableCell>
                              ))}
                            </TableRow>
                          ))
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </>
              ) : (
                <>
                  <Typography
                    sx={{ width: '100%', fontWeight: 'bold' }}
                    variant="subtitle1"
                  >
                    Manuel Muadiller
                  </Typography>
                  <TableContainer
                    className={classes.container}
                    sx={{ maxHeight: 450 }}
                  >
                    <Table
                      stickyHeader
                      fullWidth
                      aria-label="sticky table"
                      size="medium"
                      sx={{ minHeight: 100 }}
                    >
                      <TableHead>
                        <TableRow>
                          <TableCell
                            align="center"
                            style={{ width: '1px', whiteSpace: 'nowrap' }}
                          >
                            Ürün Kodu
                          </TableCell>
                          <TableCell
                            align="center"
                            style={{ width: '1px', whiteSpace: 'nowrap' }}
                          >
                            Ürün Adı
                          </TableCell>
                          <TableCell
                            align="center"
                            style={{ width: '1px', whiteSpace: 'nowrap' }}
                          >
                            Öncelik Sırası
                          </TableCell>
                          <TableCell
                            align="center"
                            style={{ width: '1px', whiteSpace: 'nowrap' }}
                          >
                            Muadil Tipi
                          </TableCell>
                          <TableCell
                            align="center"
                            style={{ width: '1px', whiteSpace: 'nowrap' }}
                          >
                            Geçerlilik Süresi
                          </TableCell>
                          <TableCell
                            align="center"
                            style={{ width: '1px', whiteSpace: 'nowrap' }}
                          >
                            Muadil Açıklama
                          </TableCell>
                          <TableCell
                            align="center"
                            style={{ width: '1px', whiteSpace: 'nowrap' }}
                          >
                            Depo Adı
                          </TableCell>
                          <TableCell
                            align="center"
                            style={{ width: '1px', whiteSpace: 'nowrap' }}
                          >
                            Stok Adet
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {detailManuelLoading == true ? (
                          <TableCell colSpan={9}>
                            <Stack
                              spacing={9}
                              alignItems="center"
                              justifyContent="center"
                            >
                              <CircularProgress size={50} color="success" />
                            </Stack>
                          </TableCell>
                        ) : (
                          productList.length > 0 &&
                          productList.map((row, index) => (
                            <TableRow key={index}>
                              <TableCell
                                align="center"
                                style={{ width: '1px', whiteSpace: 'nowrap' }}
                              >
                                {row.SKU}
                              </TableCell>
                              <TableCell
                                align="center"
                                style={{ width: '1px', whiteSpace: 'nowrap' }}
                              >
                                {row.ACIKLAMA}
                              </TableCell>
                              <TableCell
                                align="center"
                                style={{ width: '1px', whiteSpace: 'nowrap' }}
                              >
                                {row.ONCELIK_SIRASI}
                              </TableCell>
                              <TableCell
                                align="center"
                                style={{ width: '1px', whiteSpace: 'nowrap' }}
                              >
                                {row.MUADIL_TIPI}
                              </TableCell>
                              <TableCell
                                align="center"
                                style={{ width: '1px', whiteSpace: 'nowrap' }}
                              >
                                {moment(row.GECERLILIK_SURESI).format(
                                  'DD/MM/YYYY'
                                )}
                              </TableCell>
                              <TableCell
                                align="center"
                                style={{ width: '1px', whiteSpace: 'nowrap' }}
                              >
                                {row.MUADIL_ACIKLAMA}
                              </TableCell>
                              <TableCell
                                align="center"
                                style={{ width: '1px', whiteSpace: 'nowrap' }}
                              >
                                {row.StockName ? row.StockName : ''}
                              </TableCell>
                              <TableCell
                                align="center"
                                style={{ width: '1px', whiteSpace: 'nowrap' }}
                              >
                                {row.StockTotal ? row.StockTotal : ''}
                              </TableCell>
                            </TableRow>
                          ))
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </>
              )}
            </Grid>
          </DialogContent>
          <DialogActions>
            <DialogActions>
              <IconButton
                sx={{ color: '#424242' }}
                onClick={() => setEquivalentPopUp(false)}
                aria-label="close"
                component="span"
                variant="contained"
              >
                <CloseIcon />
              </IconButton>
            </DialogActions>
          </DialogActions>
        </Dialog>

        {/*Garanti Bilgileri Detay popup başlangıcı */}

        <Dialog
          open={warrantyTypePopUp}
          onClose={closeWarrantyPopUp}
          aria-describedby="alert-dialog-slide-description"
          fullWidth
          maxWidth="lg"
          PaperProps={{ sx: { borderRadius: '16px' } }}
        >
          <DialogTitle
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              backgroundColor: '#f5f5f5',
              borderBottom: '1px solid #e0e0e0',
              padding: '10px 16px'
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <VerifiedIcon sx={{ color: '#FF9800' }} />
              <Typography sx={{ fontSize: '12px', fontWeight: 700, letterSpacing: '0.5px', color: '#424242', textTransform: 'uppercase' }}>
                Garanti Bilgileri
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
              <Tooltip title="Tekrar Sorgula">
                <span>
                  <IconButton
                    size="small"
                    disabled={warrantyLoading}
                    onClick={getWarrantyType}
                    sx={{ color: '#FF9800' }}
                    aria-label="Tekrar Sorgula"
                  >
                    <RefreshIcon fontSize="small" />
                  </IconButton>
                </span>
              </Tooltip>
              <Tooltip title="Kapat">
                <IconButton size="small" onClick={closeWarrantyPopUp} sx={{ color: '#424242' }} aria-label="close">
                  <CloseIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            </Box>
          </DialogTitle>
          <DialogContent sx={{ pt: '16px !important' }}>
            <TableContainer sx={{ maxHeight: 440, border: '1px solid #e0e0e0', borderRadius: '12px' }}>
              <Table stickyHeader size="small" aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    {['Garanti Tip', 'Kalan Süre (Gün)', 'Mevcut Garanti Bilgisi', 'Garanti Başlangıç Tarihi', 'Garanti Bitiş Tarihi', 'Süre'].map((title) => (
                      <TableCell
                        key={title}
                        align="center"
                        sx={{ backgroundColor: '#f5f5f5', color: '#424242', fontSize: '11px', fontWeight: 700, whiteSpace: 'nowrap', borderBottom: '1px solid #e0e0e0' }}
                      >
                        {title}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {(warrantyLoading || warrantyError || warrantyData.length === 0) && (
                    <TableRow>
                      <TableCell colSpan={6} align="center" sx={{ py: 5, borderBottom: 'none' }}>
                        {warrantyLoading ? (
                          <Stack direction="row" spacing={1.5} alignItems="center" justifyContent="center">
                            <CircularProgress size={22} sx={{ color: '#FF9800' }} />
                            <Typography sx={{ fontSize: '12px', color: '#757575' }}>
                              Garanti bilgileri sorgulanıyor...
                            </Typography>
                          </Stack>
                        ) : (
                          <Stack spacing={1} alignItems="center">
                            <VerifiedIcon sx={{ fontSize: 36, color: warrantyError ? '#ef9a9a' : '#cfd8dc' }} />
                            <Typography sx={{ fontSize: '12px', color: warrantyError ? '#c62828' : '#757575' }}>
                              {warrantyError || 'Garanti bilgisi bulunamadı.'}
                            </Typography>
                          </Stack>
                        )}
                      </TableCell>
                    </TableRow>
                  )}
                  {!warrantyLoading && warrantyData?.map((row) => (
                    <TableRow key={row.TIP} sx={{ '&:hover': { backgroundColor: '#fff8e1' }, '&:last-child td': { borderBottom: 0 } }}>
                      <TableCell align="center" sx={{ fontSize: '12px', fontWeight: 700, color: '#263238' }}>
                        {row.TIP}
                      </TableCell>
                      <TableCell align="center">
                        <Chip
                          size="small"
                          label={row.KALAN_SURE ?? '-'}
                          sx={{
                            height: 22,
                            fontSize: '11px',
                            fontWeight: 700,
                            borderRadius: '8px',
                            backgroundColor: Number(row.KALAN_SURE) < 0 ? '#ffebee' : '#fff3e0',
                            color: Number(row.KALAN_SURE) < 0 ? '#c62828' : '#e65100'
                          }}
                        />
                      </TableCell>
                      <TableCell align="center" sx={{ fontSize: '12px', color: '#263238' }}>{row.GARANTI_VAR}</TableCell>
                      <TableCell align="center" sx={{ fontSize: '12px', color: '#263238' }}>{row.BASLANGIC_TARIHI}</TableCell>
                      <TableCell align="center" sx={{ fontSize: '12px', color: '#263238' }}>{row.BITIS_TARIHI}</TableCell>
                      <TableCell align="center" sx={{ fontSize: '12px', color: '#263238' }}>{row.SURE}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </DialogContent>
        </Dialog>

        {/*Servis Red Nedeni Var ise bu pop up açılır*/}

        <Dialog
          open={selectedServiceRefundPopUp}
          onClose={() => setSelectedServiceRefundPopUp(false)}
          aria-describedby="alert-dialog-slide-description"
          fullWidth
          maxWidth="sm"
        >
          <DialogContent>
            <Grid container spacing={2}>
              <Grid item xs={12} md={12}>
                <div style={{ height: 400, width: '100%' }}>
                  <DataGrid
                    rows={selectedRefundData}
                    columns={columns}
                    getRowId={(row) => row.DEGISIM_RED_NEDENI}
                  />
                </div>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <DialogActions>
              <IconButton
                color="primary"
                onClick={() => setSelectedServiceRefundPopUp(false)}
                aria-label="close"
                component="span"
                variant="contained"
              >
                <CloseIcon />
              </IconButton>
            </DialogActions>
          </DialogActions>
        </Dialog>
      </Card>
    </>
  );
}

export default ChangeProductInfo;
